import { render, staticRenderFns } from "./ButtonValidate.vue?vue&type=template&id=50d1201b&scoped=true&"
import script from "./ButtonValidate.vue?vue&type=script&lang=js&"
export * from "./ButtonValidate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonValidate.vue?vue&type=style&index=0&id=50d1201b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1201b",
  null
  
)

export default component.exports